var current_page = window.location.pathname.split('/').pop();
if(current_page == 'customer-account-update'){
//     document.addEventListener('DOMContentLoaded', function() {
//         var openfiled = window.location.search;
//         if(openfiled == '?rewarddatephone'){
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#dob').removeAttribute('readonly');
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#dob').removeAttribute('disabled');
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#phoneNumber').removeAttribute('readonly');
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#phoneNumber').removeAttribute('disabled');
//             document.querySelector('.customer_account_update form#updateAccountForm .field input[name="dob"]').remove();
//             document.querySelector('.customer_account_update form#updateAccountForm .field input[name="number"]').remove();
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#dob').setAttribute('name', 'dob');
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#phoneNumber').setAttribute('name', 'number');
//         }
//         if(openfiled == '?rewarddate'){
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#dob').removeAttribute('readonly');
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#dob').removeAttribute('disabled');
//             document.querySelector('.customer_account_update form#updateAccountForm .field input[name="dob"]').remove();
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#dob').setAttribute('name', 'dob');
//         }
//         if(openfiled == '?rewardphone'){
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#phoneNumber').removeAttribute('readonly');
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#phoneNumber').removeAttribute('disabled');
//             document.querySelector('.customer_account_update form#updateAccountForm .field input[name="number"]').remove();
//             document.querySelector('.customer_account_update form#updateAccountForm .field input#phoneNumber').setAttribute('name', 'number');
//         }

//         document.getElementById('updateAccountForm').addEventListener('submit', function(event) {
//         event.preventDefault();
        
//         var form = this;
//         var formData = new FormData(form);
//         var serializedFormData = new URLSearchParams(formData).toString();

//         var loader = document.querySelector('.customer_account_update form#updateAccountForm .submit_btns #loader');
//         loader.style.display = 'inline-grid';
//         document.querySelector('body').style.cursor = 'wait';
        
//         var xhr = new XMLHttpRequest();
//         xhr.open('POST', 'https://phpstack-839621-4344448.cloudwaysapps.com/api/levissa/customerupdate', true);
//         xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
//         xhr.setRequestHeader('X-Referrer', window.location.pathname);
//         xhr.onreadystatechange = function() {
//             if (xhr.readyState === XMLHttpRequest.DONE) {
//                 if (xhr.status === 200) {
//                     var response = xhr.responseText;
//                     console.log(response);
//                     setTimeout(function(){
//                         loader.style.display = 'none';
//                         document.querySelector('body').style.cursor = 'default';
//                         location.href = '/pages/red-tab-points';
//                     }, 1500);
//                 } else {
//                     console.error('Error updating data:', xhr.status, xhr.statusText);
//                 }
//             }
//         };
        
//         xhr.send(serializedFormData);
//         });
//     });
} else if (current_page == 'red-tab-points'){
//     var customer_phone = window.leviscustdata.phone;
//     var url = "https://phpstack-839621-4344448.cloudwaysapps.com/api/levissa/getcustomerpointredtab";
//     var params = { phone:window.leviscustdata.phone, shop: Shopify.shop };
//     fetch(url + "?" + new URLSearchParams(params))
//         .then(function(response) {
//         if (response.ok) {
//             return response.json();
//         } else {
//             throw new Error("Request failed with status " + response.status);
//         }
//         })
//         .then(function(result) {
//             if(result.availablepoint){
//                 var data = JSON.parse(result.availablepoint);
//                 var availpoint = data.AvailablePoints;
//                 console.log(availpoint);
//                 var pointamount = availpoint / 10;
//                 if (!isNaN(availpoint)) {
//                     document.querySelector('.page_content .account_details .reward_points span.reward_point').innerHTML = availpoint + ' POINTS (R' + pointamount + ')';
//                 } else{
//                     document.querySelector('.page_content .account_details .reward_points span.reward_point').innerHTML = '0 POINTS(R0)';
//                     console.log(availpoint);
//                 }
//             }   
//         })
//         .catch(function(error) {
//             console.log('error:' + error);
//         });
} else if (current_page == 'red-tab-points-history') {

//     var customer_phone = window.leviscustdata.phone;
//     var storeUrl = window.location.hostname;
//     var storecode = window.leviscustdata.storecode;
//     var lookupurl = "https://phpstack-839621-4344448.cloudwaysapps.com/api/levissa/customerlookup";

//     var lookupparam = {phone: customer_phone,storeUrl: storeUrl, storecode: storecode};

//     fetch(lookupurl + "?" + new URLSearchParams(lookupparam))
//         .then(function(response) {
//             if (response.ok) {
//                 return response.json();
//             } else {
//                 throw new Error("Request failed with status " + response.status);
//             }
//             })
//             .then(function(result) {
//             if(result){
//                 var data = JSON.parse(result);
              
//                 // console.log(data);
//                 if(data.ReturnCode != 823){
//                     var orders = data.Orders;
//                     if(orders != null && orders != undefined){
//                         orders.sort(function(a, b){
//                             return b.PrimaryOrderNumber.localeCompare(a.PrimaryOrderNumber);
//                         });
                    
//                         for(var key in orders){
//                             var dta = orders[key];
//                             var order_id = dta.PrimaryOrderNumber;
//                             // console.log(dta);
//                             var date = dta.OrderDate;
//                             // console.log('order_id '+order_id);
//                             // console.log('date '+date.split("T")[0].split("-"));
//                             var [year, month, day] = date.split("T")[0].split("-");
//                             var outputDateString = `${day}/${month}/${year}`;
//                             var status = 'Processing';

//                             // var RedeemPoints = dta.PointsRedeemed;
//                             var AccruedPoints = dta.OrderLevelCredits;
//                             if(AccruedPoints != 0){
//                                 var htmlContent = `
//                                     <tr class="history_content">
//                                     <td>${order_id}</td>
//                                     <td>${outputDateString}</td>
//                                     <td>+${AccruedPoints}</td>
//                                     <td>${status}</td>
//                                     <td>Online</td>
//                                     </tr>
//                                 `;
//                                 document.querySelector('#historyTable tbody').insertAdjacentHTML('beforeend', htmlContent);
//                             }
//                             // if(RedeemPoints != 0){
//                             //     var htmlContent = `
//                             //         <tr class="history_content">
//                             //         <td>${order_id}</td>
//                             //         <td>${outputDateString}</td>
//                             //         <td>-${RedeemPoints}</td>
//                             //         <td>${status}</td>
//                             //         <td>Online</td>
//                             //         </tr>
//                             //     url`;
//                             //     document.querySelector('#historyTable tbody').insertAdjacentHTML('beforeend', htmlContent);
//                             // }
//                         };
//                     }
//                 }
//                 Orderhistory();
//             }
//         })
//         .catch(function(error) {
//             console.error('error: ' + error);
//         });

//     function Orderhistory(){
//         var customer_id = window.leviscustdata.id;
//         var customer_email = window.leviscustdata.email;
//         var customer_phone = window.leviscustdata.phone;
//         var url = "https://phpstack-839621-4344448.cloudwaysapps.com/api/levissa/customeraccount";
//         var params = { id: customer_id,email: customer_email,phone: customer_phone, shop: storeUrl };
//         fetch(url + "?" + new URLSearchParams(params))
//         .then(function(response) {
//         if (response.ok) {
//             return response.json();
//         } else {
//             throw new Error("Request failed with status " + response.status);
//         }
//         })
       
//         .then(function(result) {
//         if(result.history){
//             var data = JSON.parse(result.history);
//             console.log(data);
//             if (data.ReturnCode != 172){
//                 var data_values = data.MemberTransactionResponseListDTO;
//                 // var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
//                 // if (isSafari) {
//                 //     data_values = [data_values];
//                 // }
//                 console.log(data_values);
//                 console.log(typeof data_values);
//                 if(data_values != null && data_values != undefined){
//                 // data_values.sort(function(a, b){
//                 //     return b.BillNo.localeCompare(a.BillNo);
//                 // });
//                 if (Array.isArray(data_values)) {
//                     data_values.sort(function(a, b) {
//                         return b.BillNo.localeCompare(a.BillNo);
//                     });
//                     for(var key in data_values){
  
                  
//                         var dta = data_values[key];
//                         var order_id = dta.BillNo;
//                         var date = dta.BillDate;
//                         console.log(dta);
//                         console.log(typeof date);
//                         // console.log(order_id);
//                         // console.log('date '+date.split("T")[0].split("-"));
//                         var [year, month, day] = date.split("T")[0].split("-");
//                         var outputDateString = `${day}/${month}/${year}`;
    
//                         var status = 'Completed';
//                         var storecode = dta.StoreCode;
//                         const stores1 = [
//                             { id: '3355', name: "Levi's® Store - V&A Waterfront" },
//                             { id: '3356', name: "Levi's® Store - Canal Walk" },
//                             { id: '3351', name: "Levi's® Store - Cavendish" },
//                             { id: '3352', name: "Levi's® Store - Tygervalley" },
//                             { id: '3364', name: "Levi's® Store - Sandton" },
//                             { id: '3361', name: "Levi's® Store - Eastgate" },
//                             { id: '3366', name: "Levi's® Store - Cresta" },
//                             { id: '3365', name: "Levi's® Store - Clearwater" },
//                             { id: '3358', name: "Levi's® Store - Fourways" },
//                             { id: '3362', name: "Levi's® Store - Mall Of Africa" },
//                             { id: '3360', name: "Levi's® Store - Menlyn" },
//                             { id: '3354', name: "Levi's® Store - Centurion" },
//                             { id: '3363', name: "Levi's® Store - Mall of the North" },
//                             { id: '3357', name: "Levi's® Store - Gateway" },
//                             { id: '3353', name: "Levi's® Store - Pavillion" },
//                             { id: '3359', name: "Levi's® Store - I'langa" },
//                             { id: '3350', name: "Levi's® Store - Adderley CBD" },
//                             { id: '3369', name: "Levi's® Outlet - Access Park" },
//                             { id: '3372', name: "Levi's® Outlet - Cape Gate" },
//                             { id: '3374', name: "Levi's® Outlet - Access City" },
//                             { id: '3371', name: "Levi's® Outlet - Woodmead" },
//                             { id: '3373', name: "Levi's® Outlet - East Point" },
//                             { id: '3375', name: "Levi's® Outlet - Retail Crossing" },
//                             { id: '3370', name: "Levi's® Outlet - Atterbury" },
//                             { id: '3376', name: "Levi's® Outlet - Bloemfontein" },
//                             { id: '3368', name: "Levi's® Outlet - Springfield" },
//                             { id: '3381', name: "Levi's® Store - Midlands" },
//                             { id: '3380', name: "Levi's® Store - Galleria" },
//                             { id: '3383', name: "Levi's® Store - HIGHVELD" },
//                             { id: '3379', name: "Levi's® Store - Brooklyn" },
//                             { id: '3382', name: "Levi's® Store - THAVANI" },
//                             { id: '3378', name: "Levi's® Store - FAIRLANDS WALK" },
//                             { id: '3367', name: "Levi's® Store - ROSEBANK" },
//                             { id: '3387', name: "Levi's® Store - Boardwalk" },
//                         ];
//                         var store = null;
//                         if(storecode != null){
//                             var storeObject = stores1.find(store => store.id === storecode);
//                             var store = storeObject ? storeObject.name : null;
//                         }
//                         if (store != null){
//                             console.log(store);
//                             if(store == 'LevisSA'){
//                                 var storename = 'Online';
//                             } else if (store.includes('Store')){
//                                 var storename = store.replace("Levi's® Store - ", "In-Store (") + ')';
//                                 console.log(storename);
//                             } else if (store.includes('Outlet')) {
//                                 var storename = store.replace("Levi's® Outlet - ", "In-Store (") + ')';
//                                 console.log(storename);
//                             } else {
//                                 var storename = storecode;
//                             }
//                         } else {
//                             var storename = 'Online';
//                         }
//                         var exdate = dta.Narration;
//                         if(exdate != 'POINT REDEEMED' && exdate != 'POINT LAPSED'){
//                             var AccruedPoints = parseFloat(dta.TotalAccruedPoints).toFixed(0);
//                             if(AccruedPoints != '0'){
//                                 if(AccruedPoints != 0){
//                                     var htmlContent = `
//                                         <tr class="history_content">
//                                         <td>${order_id}</td>
//                                         <td>${outputDateString}</td>
//                                         <td>+${AccruedPoints}</td>
//                                         <td>${status}</td>
//                                         <td>${storename}</td>
//                                         </tr>
//                                     `;
//                                     document.querySelector('#historyTable tbody').insertAdjacentHTML('beforeend', htmlContent);
//                                 }
//                             }
//                         }else{
//                             var RedeemPoints = parseFloat(dta.TotalRedeemPoints).toFixed(0);
//                             if(RedeemPoints != 0){
//                                 if(exdate != 'POINT LAPSED'){
//                                     var htmlContent = `
//                                         <tr class="history_content">
//                                         <td>${order_id}</td>
//                                         <td>${outputDateString}</td>
//                                         <td>-${RedeemPoints}</td>
//                                         <td>${status}</td>
//                                         <td>${storename}</td>
//                                         </tr>
//                                     `;
//                                 } else {
//                                     var htmlContent = `
//                                         <tr class="history_content">
//                                         <td>${order_id}</td>
//                                         <td>${outputDateString}</td>
//                                         <td>-${RedeemPoints}</td>
//                                         <td>Expire</td>
//                                         <td>${storename}</td>
//                                         </tr>
//                                     `;
//                                 }
//                                 document.querySelector('#historyTable tbody').insertAdjacentHTML('beforeend', htmlContent);
//                             }
//                         }
                      
                        
//                     };
//                 } else if (typeof data_values === 'object') {
//                     // [data_values].sort(function(a, b) {
//                     //     return b.BillNo.localeCompare(a.BillNo);
//                     // });
//                     var dta = data_values;
//                     var order_id = dta.BillNo;
//                     var date = dta.BillDate;
//                     console.log(dta);
//                     // console.log(order_id);
//                     // console.log('date '+date.split("T")[0].split("-"));
//                     var [year, month, day] = date.split("T")[0].split("-");
//                     var outputDateString = `${day}/${month}/${year}`;

//                     var status = 'Completed';
//                     var storecode = dta.StoreCode;
//                     const stores1 = [
//                         { id: '3355', name: "Levi's® Store - V&A Waterfront" },
//                         { id: '3356', name: "Levi's® Store - Canal Walk" },
//                         { id: '3351', name: "Levi's® Store - Cavendish" },
//                         { id: '3352', name: "Levi's® Store - Tygervalley" },
//                         { id: '3364', name: "Levi's® Store - Sandton" },
//                         { id: '3361', name: "Levi's® Store - Eastgate" },
//                         { id: '3366', name: "Levi's® Store - Cresta" },
//                         { id: '3365', name: "Levi's® Store - Clearwater" },
//                         { id: '3358', name: "Levi's® Store - Fourways" },
//                         { id: '3362', name: "Levi's® Store - Mall Of Africa" },
//                         { id: '3360', name: "Levi's® Store - Menlyn" },
//                         { id: '3354', name: "Levi's® Store - Centurion" },
//                         { id: '3363', name: "Levi's® Store - Mall of the North" },
//                         { id: '3357', name: "Levi's® Store - Gateway" },
//                         { id: '3353', name: "Levi's® Store - Pavillion" },
//                         { id: '3359', name: "Levi's® Store - I'langa" },
//                         { id: '3350', name: "Levi's® Store - Adderley CBD" },
//                         { id: '3369', name: "Levi's® Outlet - Access Park" },
//                         { id: '3372', name: "Levi's® Outlet - Cape Gate" },
//                         { id: '3374', name: "Levi's® Outlet - Access City" },
//                         { id: '3371', name: "Levi's® Outlet - Woodmead" },
//                         { id: '3373', name: "Levi's® Outlet - East Point" },
//                         { id: '3375', name: "Levi's® Outlet - Retail Crossing" },
//                         { id: '3370', name: "Levi's® Outlet - Atterbury" },
//                         { id: '3376', name: "Levi's® Outlet - Bloemfontein" },
//                         { id: '3368', name: "Levi's® Outlet - Springfield" },
//                         { id: '3381', name: "Levi's® Store - Midlands" },
//                         { id: '3380', name: "Levi's® Store - Galleria" },
//                         { id: '3383', name: "Levi's® Store - HIGHVELD" },
//                         { id: '3379', name: "Levi's® Store - Brooklyn" },
//                         { id: '3382', name: "Levi's® Store - THAVANI" },
//                         { id: '3378', name: "Levi's® Store - FAIRLANDS WALK" },
//                         { id: '3367', name: "Levi's® Store - ROSEBANK" },
//                     ];
//                     var store = null;
//                     if(storecode != null){
//                         var storeObject = stores1.find(store => store.id === storecode);
//                         var store = storeObject ? storeObject.name : null;
//                     }
//                     if (store != null){
//                         console.log(store);
//                         if(store == 'LevisSA'){
//                             var storename = 'Online';
//                         } else if (store.includes('Store')){
//                             var storename = store.replace("Levi's® Store - ", "In-Store (") + ')';
//                             console.log(storename);
//                         } else if (store.includes('Outlet')) {
//                             var storename = store.replace("Levi's® Outlet - ", "In-Store (") + ')';
//                             console.log(storename);
//                         } else {
//                             var storename = storecode;
//                         }
//                     } else {
//                         var storename = 'Online';
//                     }
//                     var exdate = dta.Narration;
//                     if(exdate != 'POINT REDEEMED' && exdate != 'POINT LAPSED'){
//                         var AccruedPoints = parseFloat(dta.TotalAccruedPoints).toFixed(0);
//                         if(AccruedPoints != '0'){
//                             if(AccruedPoints != 0){
//                                 var htmlContent = `
//                                     <tr class="history_content">
//                                     <td>${order_id}</td>
//                                     <td>${outputDateString}</td>
//                                     <td>+${AccruedPoints}</td>
//                                     <td>${status}</td>
//                                     <td>${storename}</td>
//                                     </tr>
//                                 `;
//                                 document.querySelector('#historyTable tbody').insertAdjacentHTML('beforeend', htmlContent);
//                             }
//                         }
//                     }else{
//                         var RedeemPoints = parseFloat(dta.TotalRedeemPoints).toFixed(0);
//                         if(RedeemPoints != 0){
//                             if(exdate != 'POINT LAPSED'){
//                                 var htmlContent = `
//                                     <tr class="history_content">
//                                     <td>${order_id}</td>
//                                     <td>${outputDateString}</td>
//                                     <td>-${RedeemPoints}</td>
//                                     <td>${status}</td>
//                                     <td>${storename}</td>
//                                     </tr>
//                                 `;
//                             } else {
//                                 var htmlContent = `
//                                     <tr class="history_content">
//                                     <td>${order_id}</td>
//                                     <td>${outputDateString}</td>
//                                     <td>-${RedeemPoints}</td>
//                                     <td>Expire</td>
//                                     <td>${storename}</td>
//                                     </tr>
//                                 `;
//                             }
//                             document.querySelector('#historyTable tbody').insertAdjacentHTML('beforeend', htmlContent);
//                         }
//                     }
//                 }
                  
                
//             }else{
//                 document.querySelector('.account_details_history table#historyTable tbody .loader').style.display = 'none';
//                 if(document.querySelectorAll('.account_details_history table#historyTable tbody .history_content').length == 0){
//                     var htmlContent = 'You Have no record.';
//                     document.querySelector('#historyTable tbody').insertAdjacentHTML('beforeend', htmlContent);
//                 }
//             }
//         }else{
//             document.querySelector('.account_details_history table#historyTable tbody .loader').style.display = 'none';
//             if(document.querySelectorAll('.account_details_history table#historyTable tbody .history_content').length == 0){
//                 var htmlContent = 'You Have no record.';
//                 document.querySelector('#historyTable tbody').insertAdjacentHTML('beforeend', htmlContent);
//             }
//         }
//         if(document.querySelectorAll('.account_details_history table#historyTable tbody .history_content').length > 0){
//             const tableContainer = document.getElementById('historyTableContainer');
//             const table = document.getElementById('historyTable');
//             const rows = Array.from(table.querySelectorAll('.history_content'));
//             const perPage = 5;
//             let currentPage = 0;

//             function showRows() {
//             const start = currentPage * perPage;
//             const end = start + perPage;

//             rows.forEach((row, index) => {
//                 if (index >= start && index < end) {
//                 row.classList.add('active');
//                 } else {
//                 row.classList.remove('active');
//                 }
//             });
//             }

//             function previousPage() {
//             if (currentPage > 0) {
//                 currentPage--;
//                 showRows();
//                 updatePaginationButtons();
//                 tableContainer.scrollTop = 0;
//             }
//             }

//             function nextPage() {
//             const totalPages = Math.ceil(rows.length / perPage);
//             if (currentPage < totalPages - 1) {
//                 currentPage++;
//                 showRows();
//                 updatePaginationButtons();
//                 tableContainer.scrollTop = 0;
//             }
//             }

//             function updatePaginationButtons() {
//             const totalPages = Math.ceil(rows.length / perPage);
//             const prevBtn = document.getElementById('prevBtn');
//             const nextBtn = document.getElementById('nextBtn');
//             const pageNumbersContainer = document.getElementById('pageNumbers');

//             pageNumbersContainer.innerHTML = '';

//             for (let i = 0; i < totalPages; i++) {
//                 const pageNumber = i + 1;
//                 const pageNumberBtn = document.createElement('button');
//                 pageNumberBtn.textContent = pageNumber;
//                 pageNumberBtn.className = "pageNumber";
//                 if (i === currentPage) {
//                 pageNumberBtn.classList.add('activePage');
//                 }
//                 pageNumberBtn.addEventListener('click', function() {
//                 currentPage = i;
//                 showRows();
//                 updatePaginationButtons();
//                 tableContainer.scrollTop = 0;
//                 });
//                 pageNumbersContainer.appendChild(pageNumberBtn);
//             }

//             prevBtn.style.display = currentPage === 0 ? 'none' : 'inline-block';
//             nextBtn.style.display = currentPage === totalPages - 1 ? 'none' : 'inline-block';
//             prevBtn.addEventListener('click', previousPage);
//             nextBtn.addEventListener('click', nextPage);
//             }

//             showRows();
//             updatePaginationButtons();

//             var rows_1 = document.querySelectorAll(".history_content td:nth-child(3)");

//             rows_1.forEach(function(cell) {
//                 var value = cell.textContent.trim();
//                 if (value.includes('+')) {
//                     cell.classList.add('plus_value');
//                 } else if (value.includes('-')) {
//                     cell.classList.add('minus_value');
//                 }
//             });

//             document.querySelector('.account_details_history table#historyTable tbody .loader').style.display = 'none';
//         }
//         }
//         })
//         .catch(function(error) {
//         console.error('error: ' + error);
//         });
//     }
}
else if (current_page == 'login') {
    // $(document).ready(function(){
    //     const stores = [
    //         { id: '3355', name: "Levi's® Store - V&A Waterfront" },
    //         { id: '3356', name: "Levi's® Store - Canal Walk" },
    //         { id: '3351', name: "Levi's® Store - Cavendish" },
    //         { id: '3352', name: "Levi's® Store - Tygervalley" },
    //         { id: '3364', name: "Levi's® Store - Sandton" },
    //         { id: '3361', name: "Levi's® Store - Eastgate" },
    //         { id: '3366', name: "Levi's® Store - Cresta" },
    //         { id: '3365', name: "Levi's® Store - Clearwater" },
    //         { id: '3358', name: "Levi's® Store - Fourways" },
    //         { id: '3362', name: "Levi's® Store - Mall Of Africa" },
    //         { id: '3360', name: "Levi's® Store - Menlyn" },
    //         { id: '3354', name: "Levi's® Store - Centurion" },
    //         { id: '3363', name: "Levi's® Store - Mall of the North" },
    //         { id: '3357', name: "Levi's® Store - Gateway" },
    //         { id: '3353', name: "Levi's® Store - Pavillion" },
    //         { id: '3359', name: "Levi's® Store - I'langa" },
    //         { id: '3350', name: "Levi's® Store - Adderley CBD" },
    //         { id: '3369', name: "Levi's® Outlet - Access Park" },
    //         { id: '3372', name: "Levi's® Outlet - Cape Gate" },
    //         { id: '3374', name: "Levi's® Outlet - Access City" },
    //         { id: '3371', name: "Levi's® Outlet - Woodmead" },
    //         { id: '3373', name: "Levi's® Outlet - East Point" },
    //         { id: '3375', name: "Levi's® Outlet - Retail Crossing" },
    //         { id: '3370', name: "Levi's® Outlet - Atterbury" },
    //         { id: '3376', name: "Levi's® Outlet - Bloemfontein" },
    //         { id: '3368', name: "Levi's® Outlet - Springfield" },
    //         { id: '3381', name: "Levi's® Store - Midlands" },
    //         { id: '3380', name: "Levi's® Store - Galleria" },
    //         { id: '3383', name: "Levi's® Store - HIGHVELD" },
    //         { id: '3379', name: "Levi's® Store - Brooklyn" },
    //         { id: '3382', name: "Levi's® Store - THAVANI" },
    //         { id: '3378', name: "Levi's® Store - FAIRLANDS WALK" },
    //         { id: '3367', name: "Levi's® Store - ROSEBANK" },
    //     ];
    //     var storecode = (new URLSearchParams(window.location.search)).get('store');
    //     if(storecode != null){
    //         var checkInterval1 = setInterval(function() {
    //             var storefield1 = $('div#sotp-widget .login-box .login-inputBox');
    //             if (storefield1.length > 0) {
    //                 clearInterval(checkInterval1);
    //                 if(storecode != null){
    //                     var frstore = stores.find(store => store.id === storecode).name;
    //                     var htmlContent = `<div class="storename">Store : <span class="store">${frstore}</span></div>`;
    //                     storefield1.append(htmlContent);
    //                 }
    //             }
    //         }, 1000);
    //         var checkInterval = setInterval(function() {
    //             var storefield = $('div#sotp-widget .update-user-box:not(.hideBox) .customFieldsBox .custom_input:has(input[name="Store"])');
    //             if (storefield.length > 0) {
    //                 clearInterval(checkInterval);
    //                 if(storecode != null){
    //                     storefield.find('input').val(storecode);
    //                     var store = stores.find(store => store.id === storecode).name;
    //                     var htmlContent = `<span class="storename">${store}</span>`;
    //                     storefield.append(htmlContent);
    //                 }
    //             }
    //         }, 1000);
    //     } else {
    //         $('div#sotp-widget .update-user-box .customFieldsBox .custom_field:has(input[name="Store"])').hide();
    //     }
    // });
} else if(current_page == 'customer-service'){
//     document.addEventListener('DOMContentLoaded', function() {
//         function checkAndPopulateForm() {
//             var form = document.querySelector('.customer-service .contetn-container .main-content .customer-form form');
//             if (form) {
//                 clearInterval(checkFormInterval);
//                 populateForm();
//                 document.querySelector('.customer-service .contetn-container .main-content .customer-form form').addEventListener('submit', function() {
//                     saveData();
//                     setTimeout(function(){
//                         populateForm();
//                     }, 1000);
//                     setTimeout(function(){
//                         document.querySelector('.customer-service .contetn-container .main-content .customer-form .message.success .dismiss').click();
//                     }, 5000);
//                 });
//             }
//         }
//         var checkFormInterval = setInterval(checkAndPopulateForm, 500);
//     });

//     function saveData() {
//         var name = document.querySelector(".customer-service .contetn-container .main-content .customer-form input[placeholder='Name']").value;
//         var email = document.querySelector(".customer-service .contetn-container .main-content .customer-form input[name='email']").value;
//         var saveInfoCheckbox = document.querySelector('.customer-service .contetn-container .main-content .customer-form input[type="checkbox"]');
        
//         if (saveInfoCheckbox.checked) {
//             localStorage.setItem("name", name);
//             localStorage.setItem("email", email);
//         } 
//         // else {
//         //   localStorage.removeItem("name");
//         //   localStorage.removeItem("email");
//         // }
//     }
    
//     function populateForm() {
//         var name = localStorage.getItem("name");
//         var email = localStorage.getItem("email");
//         var saveInfoCheckbox = document.querySelector('.customer-service .contetn-container .main-content .customer-form input[type="checkbox"]');
        
//         if (name && email) {
//             document.querySelector(".customer-service .contetn-container .main-content .customer-form input[placeholder='Name']").value = name;
//             document.querySelector(".customer-service .contetn-container .main-content .customer-form input[name='email']").value = email;
//             saveInfoCheckbox.checked = true;
//         }
//     }
} else if(current_page == 'redtab-offline-register'){
  document.addEventListener('DOMContentLoaded', function() {

    const stores = [
        { id: '3355', name: "Levi's® Store - V&A Waterfront" },
        { id: '3356', name: "Levi's® Store - Canal Walk" },
        { id: '3351', name: "Levi's® Store - Cavendish" },
        { id: '3352', name: "Levi's® Store - Tygervalley" },
        { id: '3364', name: "Levi's® Store - Sandton" },
        { id: '3361', name: "Levi's® Store - Eastgate" },
        { id: '3366', name: "Levi's® Store - Cresta" },
        { id: '3365', name: "Levi's® Store - Clearwater" },
        { id: '3358', name: "Levi's® Store - Fourways" },
        { id: '3362', name: "Levi's® Store - Mall Of Africa" },
        { id: '3360', name: "Levi's® Store - Menlyn" },
        { id: '3354', name: "Levi's® Store - Centurion" },
        { id: '3363', name: "Levi's® Store - Mall of the North" },
        { id: '3357', name: "Levi's® Store - Gateway" },
        { id: '3353', name: "Levi's® Store - Pavillion" },
        { id: '3359', name: "Levi's® Store - I'langa" },
        { id: '3350', name: "Levi's® Store - Adderley CBD" },
        { id: '3369', name: "Levi's® Outlet - Access Park" },
        { id: '3372', name: "Levi's® Outlet - Cape Gate" },
        { id: '3374', name: "Levi's® Outlet - Access City" },
        { id: '3371', name: "Levi's® Outlet - Woodmead" },
        { id: '3373', name: "Levi's® Outlet - East Point" },
        { id: '3375', name: "Levi's® Outlet - Retail Crossing" },
        { id: '3370', name: "Levi's® Outlet - Atterbury" },
        { id: '3376', name: "Levi's® Outlet - Bloemfontein" },
        { id: '3368', name: "Levi's® Outlet - Springfield" },
        { id: '3381', name: "Levi's® Store - Midlands" },
        { id: '3380', name: "Levi's® Store - Galleria" },
        { id: '3383', name: "Levi's® Store - HIGHVELD" },
        { id: '3379', name: "Levi's® Store - Brooklyn" },
        { id: '3382', name: "Levi's® Store - THAVANI" },
        { id: '3378', name: "Levi's® Store - FAIRLANDS WALK" },
        { id: '3367', name: "Levi's® Store - ROSEBANK" },
        { id: '3387', name: "Levi's® Store - Boardwalk" },
        { id: '3385', name: "Levi's® Store - Greenacres" },
        { id: '3386', name: "Levi's® Store - Levi Somerset" },
        { id: '3388', name: "Levi's® Store - Levi Outlet Fourways Crossing" },
        { id: '3899', name: "Levi's® Store - Levi Wonderpark" }

    ];
    var storecode = (new URLSearchParams(window.location.search)).get('store');
    if(storecode != null){
        var checkInterval1 = setInterval(function() {
            var storefield1 = $('.offline-form .main-form form input#storecode');
            if (storefield1.length > 0) {
                clearInterval(checkInterval1);
                if(storecode != null){
                    var frstore = stores.find(store => store.id === storecode).name;
                    storefield1.val(storecode);
                    var htmlContent = `<div class="storename">Store : <span class="store">${frstore}</span></div>`;
                    storefield1.after(htmlContent);
                }
            }
        }, 1000);
    }

    var loader = document.querySelector('.offline-form .main-form .loader');
    
    document.querySelector('.offline-form .main-form form#conditionalForm').addEventListener('submit', function(event) {
      event.preventDefault();
      
      
      var customer_phone = $(this).find('input#phone').val();
      var customer_email = $(this).find('input#email').val();
      var form = this;
      var formData = new FormData(form);
      var serializedFormData = new URLSearchParams(formData).toString();

      loader.classList.add('visible');
      
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://phpstack-839621-4344448.cloudwaysapps.com/api/levissa/iscustomer', true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onreadystatechange = function() {
          if (xhr.readyState === XMLHttpRequest.DONE) {
              if (xhr.status === 200) {
                var response = xhr.responseText;
                var responsedata = JSON.parse(response);
                console.log(responsedata.data);
                if(responsedata.data == 0){
                    var newDiv = document.createElement("div");
                    newDiv.classList.add("iscustomer");
                    var ptag = document.createElement("p");
                    ptag.classList.add('iscustomer-qa');
                    ptag.innerHTML = 'You are already registered in-store, want to link your Red Tab account online?';
                    var redirecttag = document.createElement("a");
                    redirecttag.classList.add('redirect-link');
                    redirecttag.setAttribute('href','/account/login');
                    redirecttag.innerHTML = 'Sign Up';
                    // var yestag = document.createElement("a");
                    // yestag.classList.add('yes-link');
                    // yestag.setAttribute('href','/account/login');
                    // yestag.innerHTML = 'Yes';
                    // var notag = document.createElement("a");
                    // notag.classList.add('no-link');
                    // notag.setAttribute('href','/');
                    // notag.innerHTML = 'No';
                    newDiv.appendChild(ptag);
                    newDiv.appendChild(redirecttag);
                    // newDiv.appendChild(yestag);
                    // newDiv.appendChild(notag);
                    var referenceElement = document.querySelector('.offline-form .main-form form#conditionalForm');
                    referenceElement.style.display = "none";
                    loader.classList.remove('visible');
                    referenceElement.parentNode.insertBefore(newDiv, referenceElement.nextSibling);
                } else {
                //   var referenceElement = document.querySelector('.offline-form .main-form form#conditionalForm');
                //   referenceElement.style.display = "none";
                //   var newform = document.querySelector('.offline-form .main-form div#additionalFields');
                //   newform.style.display = "block";
                //   loader.classList.remove('visible');
                //   newform.querySelector('form#customercreation input#email').value = customer_email;
                //   newform.querySelector('form#customercreation input#phone').value = customer_phone;
                    creatnewaccount(serializedFormData);
                }
              } else {
                  console.error('Error updating data:', xhr.status, xhr.statusText);
              }
          }
      };
      xhr.send(serializedFormData);
    });
    function creatnewaccount(serializedFormData){
      
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://phpstack-839621-4344448.cloudwaysapps.com/api/levissa/customercreate', true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onreadystatechange = function() {
          if (xhr.readyState === XMLHttpRequest.DONE) {
              if (xhr.status === 200) {
                var response = xhr.responseText;
                var responsedata = JSON.parse(response);
                if(responsedata.ReturnCode == 0){
                    var newform1 = document.querySelector('.offline-form .main-form form#conditionalForm');
                    newform1.style.display = "none";
                    loader.classList.remove('visible');
                    var successmessage = `<p class="success_message">Thank you for providing your details. A SMS will be sent to you to complete your registration details. If you would like to link your Red Tab account online, <a href="/account/login">click here</a>.</p>`;
                    newform1.insertAdjacentHTML('afterend', successmessage);
                } else if(responsedata.ReturnCode != 200){
                    var newform1 = document.querySelector('.offline-form .main-form form#conditionalForm');
                    newform1.style.display = "none";
                    loader.classList.remove('visible');
                    var successmessage = `<p class="error_message">There was an error in registration. Please contact store manager.</p>`;
                    newform1.insertAdjacentHTML('afterend', successmessage);
                }
              } else {
                  console.error('Error updating data:', xhr.status, xhr.statusText);
              }
          }
      };
      xhr.send(serializedFormData);
    };
  });
}  else if(current_page == 'account'){
//     // $(document).ready(function(){
//     //     console.log('Account Page loaded');
//     // });
}

// $(window).on('load', function () {
//     if ($('body').attr('data-template') == 'product') {

//         const order = ["40MM", "43MM", "44MM", "45MM", "48MM", "51MM", "53MM", "57MM", "UK 2", "UK 2.5", "UK 3", "UK 3.5", "UK 4", "UK 4.5", "UK 5", "UK 5.5", "UK 6", "UK 6.5", "UK 7", "UK 7.5", "UK 8", "UK 8.5", "UK 9", "UK 9.5", "UK 10", "UK 10.5", "UK 11", "UK 11.5", "UK 12", "UK 12.5", "XXS", "XS", "S", "S-M", "S/M", "M", "L", "L-XL", "L/XL", "XL", "XXL", "2XL", "3XL", "4XL", "5XL", "One Size", "OSFA", "OSFM", "1", "1.5", "2", "2.5", "3", "3.5", "4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "13.5", "14", "14.5", "15", "15.5", "16", "16.5", "17", "17.5", "18", "18.5", "19", "19.5", "20", "20.5", "21", "21.5", "22", "22.5", "23", "23.5", "24", "24.5", "25", "25.5", "26", "26.5", "27", "27.5", "28", "28.5", "29", "29.5", "30", "30.5", "31", "31.5", "32", "32.5", "33", "33.5", "34", "34.5", "35", "35.5", "36", "36.5", "37", "37.5", "38", "38.5", "39", "39.5", "40", "40.5", "41", "41.5", "42", "42.5", "43", "43.5", "44", "44.5", "45", "45.5", "46", "46.5", "47", "47.5", "48", "48.5", "49", "49.5", "50", "50.5", "51", "51.5", "52", "52.5", "53", "53.5", "54", "54.5", "55", "55.5", "56", "56.5", "57", "57.5", "58", "58.5", "59", "59.5", "60", "60.5", "75", "80", "85", "90", "95", "100", "105", "405", "445"];

//         function sortAndAppendElements(selector) {
//             const elements = document.querySelectorAll(selector);
//             elements.forEach(ul => {
//                 const liElements = Array.from(ul.querySelectorAll('div.product-size-btn-block'));
//                 liElements.sort((a, b) => {
//                     const aValue = a.querySelector('input').value;
//                     const bValue = b.querySelector('input').value;
//                     return order.indexOf(aValue) - order.indexOf(bValue);
//                 });

//                 ul.innerHTML = '';
//                 liElements.forEach(li => ul.appendChild(li));
//             });
//         }

//         sortAndAppendElements('.product__info-wrapper variant-selects fieldset[data-option="size"] .product-pill-block');
//         sortAndAppendElements('.product__info-wrapper variant-selects fieldset[data-option="length"] .product-pill-block');
//     }
// });